import React, {useState} from "react";
import connection from "../../connection";
import general from "../../general";
import SweetAlert from "../../components/SweetAlertWrapper";
import CustomInput from "../../components/CustomInput/CustomInput";
import InputLabel from "@material-ui/core/InputLabel";
import {Chip, Slider, TextField} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import {primaryColor, warningColor} from "../../assets/jss/material-dashboard-pro-react";
import formacoesStyle from "../../assets/jss/material-dashboard-pro-react/views/formacoesStyle";
import Switch from "@material-ui/core/Switch";
import Popover from "@material-ui/core/Popover";
import ReactTable from "../../components/ReactTableWrapper";
import UserSearch from "../../components/UserSearch";

// halo do thumb do slider da nota: pseudo-classes não dão para inline, reaproveita-se o estilo das formações
const useSliderNotaStyles = makeStyles({
  sliderNota: formacoesStyle.sliderNota,
  sliderNotaAviso: formacoesStyle.sliderNotaAviso
});

let acoes = {
  FORMACAO_AVALIAR: {
    text: "Avaliar Formando",
    color: "success",
    callback: async (classes, extra, finished) => {
      console.log(extra);

      let avaliacao = null;
      let justificacao = "";
      window.App.openModal(<SweetAlert
        title={"Avaliar Participação"}
        onConfirm={() => {
          if (avaliacao === null)
            return general.error("Por favor preencha a avaliação");
          if (justificacao.trim() === "" && avaliacao < 50)
            return general.error("É necessário justificar as avaliações negativas");

          avaliacao = parseInt(avaliacao);

          connection.post("formacao/participante/avaliar", {
            formacao: extra.formacao,
            utilizador: extra.utilizador,
            avaliacao: avaliacao,
            justificacao: justificacao,
          }, () => {
            general.success("Avaliação enviada.", "Sucesso");
            window.App.hideModal();
            finished && finished();
          });
        }}
        onCancel={() => window.App.hideModal()}
        confirmBtnText="Confirmar"
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <p style={{textAlign: "center"}}><strong>Nome: </strong>{extra.nome}</p>
        <CustomInput
          labelProps={{
            shrink: true
          }}
          labelText="Avaliação"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "number",
            min: "0",
            max: "100",
            placeholder: "0 - 100",
            onChange: (e) => {
              avaliacao = e.target.value
            }
          }}
        />
        <div style={{height: 15}}/>
        <InputLabel shrink={true}>
          Justificação
        </InputLabel>
        <CustomInput
          formControlProps={{
            fullWidth: true,
            style: {padding: 0, margin: 0}
          }}
          inputProps={{
            type: "text",
            placeholder: "Obrigatório preencher em caso negativo (<50 valores)",
            multiline: true,
            rows: 3,
            onChange: (e) => {
              justificacao = e.target.value
            }
          }}
        />
      </SweetAlert>);

    }
  },
  FORMACAO_MARCAR_PRESENCA: {
    text: "Marcar Presença",
    color: "info",
    callback: async (classes, extra, finished) => {
      connection.post("formacao/participante/marcar_presenca", {
        formacao: extra.formacao,
        formando: extra.utilizador
      }, () => {
        general.success("Presença marcada com sucesso.", "Sucesso");
        finished && finished();
      });
    }
  },
  FORMACAO_MARCAR_FALTA: {
    text: "Marcar Falta",
    color: "warning",
    callback: async (classes, extra, finished) => {
      window.App.openModal(<SweetAlert
        warning
        onConfirm={() => {
          window.App.hideModal();
          connection.post("formacao/participante/marcar_falta", {
            formacao: extra.formacao,
            formando: extra.utilizador
          }, () => {
            general.success("Falta marcada com sucesso.", "Sucesso");
            finished && finished();
          });
        }}
        onCancel={() => window.App.hideModal()}
        confirmBtnText="Confirmar"
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      ><p style={{textAlign: "center"}}>Tem a certeza que pretende marcar falta ao participante <span style={{whiteSpace: "nowrap"}}>{extra.nome}</span>?</p></SweetAlert>);
    }
  },
  PERCURSO_APROVAR_DISCERNIMENTO: {
    text: "Aprovar Discernimento",
    color: "info",
    callback: async (classes, extra, finished) => {
      window.App.openModal(<SweetAlert
        warning
        onConfirm={() => {
          window.App.hideModal();
          connection.post("percurso/participante/aprovar_discernimento", {
            percurso: extra.percurso,
            participante: extra.utilizador
          }, () => {
            general.success("Aprovou o discernimento do participante com sucesso", "Sucesso");
            finished && finished();
          });
        }}
        onCancel={() => window.App.hideModal()}
        confirmBtnText="Confirmar"
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      ><p style={{textAlign: "center"}}>Tem a certeza que pretende aprovar o discernimento do participante <span style={{whiteSpace: "nowrap"}}>{extra.nome}</span>?</p></SweetAlert>);
    }
  },
  PERCURSO_APROVAR_ESTAGIO: {
    text: "Aprovar Estágio",
    color: "info",
    callback: async (classes, extra, finished) => {
      window.App.openModal(<SweetAlert
        warning
        onConfirm={() => {
          window.App.hideModal();
          connection.post("percurso/participante/aprovar_estagio", {
            percurso: extra.percurso,
            participante: extra.utilizador
          }, () => {
            general.success("Aprovou o estágio do participante com sucesso", "Sucesso");
            finished && finished();
          });
        }}
        onCancel={() => window.App.hideModal()}
        confirmBtnText="Confirmar"
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      ><p style={{textAlign: "center"}}>Tem a certeza que pretende aprovar o estágio do participante <span style={{whiteSpace: "nowrap"}}>{extra.nome}</span>?</p></SweetAlert>);
    }
  },
  APROVAR_PERCURSO_CONCLUIDO: {
    text: "Aprovar Conclusão",
    color: "info",
    callback: async (classes, extra, finished) => {
      window.App.openModal(<SweetAlert
        warning
        onConfirm={() => {
          connection.post("dashboard/aprovar_conclusao", {
            percurso: extra.percurso,
            dirigente: extra.id,
            grupo_fluxo: extra.grupo_fluxo
          }, () => {
            general.success("Aprovou a conclusão do participante com sucesso", "Sucesso");
            window.App.hideModal();
            finished && finished();
          });
        }}
        onCancel={() => window.App.hideModal()}
        confirmBtnCssClass={
          classes.button + " " + classes.primary
        }
        cancelBtnCssClass={
          classes.button
        }
        confirmBtnText="Confirmar"
        cancelBtnText="Agora Não"
        showCancel
      >
        Clique em "Confirmar" para aprovar a conclusão no {extra.grupo_fluxo} do(a) dirigente {extra.nome}, com o NIN ({extra.nin}).
      </SweetAlert>);
    }
  },
  ANULAR_INSCRICAO: {
    text: "Anular Inscrição",
    color: "warning",
    callback: async (classes, extra, finished) => {
      window.App.openModal(<SweetAlert
        warning
        onConfirm={() => {
          window.App.hideModal();
          let tipo = extra.tipo_acontecimento;
          connection.post(tipo + "/candidato/anular_inscricao", {
            [tipo]: {
              curso: extra.curso,
              formacao: extra.formacao
            }[tipo],
            formando: extra.utilizador
          }, () => {
            general.success("Incrição anulada com sucesso.", "Sucesso");
            finished && finished();
          });
        }}
        onCancel={() => window.App.hideModal()}
        confirmBtnText="Confirmar"
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <p style={{textAlign: "center"}}>
          Tem a certeza que pretende anular a inscrição de <span style={{whiteSpace: "nowrap"}}>{extra.nome}</span>?
        </p>
        {extra.tipo_acontecimento === "formacao" && <p style={{textAlign: "center"}}>
          O(A) candidato(a) terá sua candidatura cancelada e será notificado(a) por email.
        </p>}
        {extra.tipo_acontecimento === "curso" && <p>
          <strong>ATENÇÃO: caso este {{curso: "curso"}[extra.tipo_acontecimento]} esteja enquadrado num percurso, o formando deverá ser inscrito manualmente num outro curso do mesmo tipo.</strong>
        </p>}
      </SweetAlert>);
    }
  },
  MOVER_PARTICIPACAO_PERCURSO: {
    text: "Mover Participação",
    color: "warning",
    callback: async (classes, extra, finished) => {
      let novo_percurso = null;
      window.App.openModal(<SweetAlert
        style={{width: 520}}
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Mudar para o percurso</span>
        </div>)}
        onConfirm={async () => {
          let result = await connection.post("percurso/candidatos/mover_pif", {
            percurso_origem: extra.percurso,
            percurso_destino: novo_percurso,
            candidatos: [extra.id]
          });
          window.App.hist.push("/percurso/" + result.id);
          window.App.hideModal();
          general.success("Percurso alterado com sucesso", "Sucesso");
        }}
        onCancel={() => window.App.hideModal()}
        confirmBtnText="Mover"
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <form autoComplete="off" style={{padding: "0 10px"}}>
          <CustomInput
            labelText="Código do percurso de destino"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              type: "text",
              name: "designacao",
              onChange: (e) => {
                novo_percurso = e.target.value;
              }
            }}
          />
        </form>
      </SweetAlert>);
    }
  },
  MOVER_INSCRICAO: {
    text: "Mover Inscrição",
    color: "warning",
    callback: async (classes, extra, finished) => {
      let novo_curso = null;
      window.App.openModal(<SweetAlert
        style={{width: 520}}
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Mudar para o curso</span>
        </div>)}
        onConfirm={async () => {
          let result = await connection.post("curso/candidatos/mover", {
            curso_origem: extra.curso,
            curso_destino: novo_curso,
            candidatos: [extra.id]
          });
          window.App.hist.push("/curso/" + result.id);
          window.App.hideModal();
          general.success("Curso alterado com sucesso", "Sucesso");
        }}
        onCancel={() => window.App.hideModal()}
        confirmBtnText="Mover"
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <form autoComplete="off" style={{padding: "0 10px"}}>
          <CustomInput
            labelText="Código do curso de destino"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              type: "text",
              name: "designacao",
              onChange: (e) => {
                novo_curso = e.target.value;
              }
            }}
          />
        </form>
      </SweetAlert>);
    }
  },
  MOVER_INSCRICAO_MODULO: {
    text: "Mover Inscrição",
    color: "warning",
    callback: async (classes, extra, finished) => {
      let nova_formacao = null;

      window.App.openModal(<SweetAlert
        style={{width: 520}}
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Mudar para a formação</span>
        </div>)}
        onConfirm={async () => {
          let result = await connection.post("formacao/candidatos/mover", {
            formacao_origem: extra.formacao,
            formacao_destino: nova_formacao,
            candidatos: [extra.id]
          });
          window.App.hist.push("/formacao/" + result.id);
          window.App.hideModal();
          general.success("Formação alterada com sucesso", "Sucesso");
        }}
        onCancel={() => window.App.hideModal()}
        confirmBtnText="Mover"
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <form autoComplete="off" style={{padding: "0 10px"}}>
          <CustomInput
            labelText="Formação de destino #"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              type: "text",
              name: "designacao",
              onChange: (e) => {
                nova_formacao = e.target.value;
              }
            }}
          />
        </form>
      </SweetAlert>);
    }
  },
  APROVAR_REGISTO: {
    text: "Aprovar Registo",
    color: "primary",
    callback: async (classes, extra, finished) => {
      window.App.openModal(<SweetAlert
        warning
        onConfirm={() => {
          window.App.hideModal();
          let tipo = extra.tipo_acontecimento;
          console.log(tipo + "/participante/aprovar_registo")
          connection.post(tipo + "/participante/aprovar_registo", {
            [tipo]: {percurso: extra.percurso}[tipo] || {curso: extra.curso}[tipo] || {formacao: extra.formacao}[tipo],
            candidato: extra.utilizador
          }, () => {
            general.success("Candidatura validada com sucesso.", "Sucesso");
            finished && finished();
          });
        }}
        onCancel={() => window.App.hideModal()}
        confirmBtnText="Confirmar"
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <p style={{textAlign: "center"}}>
          Tem a certeza que pretende aprovar o registo de <span style={{whiteSpace: "nowrap"}}>{extra.nome}</span>?
        </p>
        <p style={{textAlign: "center"}}>
          O(A) candidato(a) será aprovado como participante e será notificado(a) por email.
        </p>
      </SweetAlert>);
    }
  },
  APROVAR_PAGAMENTO: {
    text: "Pago em Dinheiro",
    color: "primary",
    callback: async (classes, extra, finished) => {
      let valor_pago_em_dinheiro = null;

      window.App.openModal(<SweetAlert
        style={{width: 520}}
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Pagamento em dinheiro</span>
        </div>)}
        onConfirm={() => {
          window.App.hideModal();
          let tipo = extra.tipo_acontecimento;
          console.log(tipo + "/participante/aprovar_pagamento")
          connection.post(tipo + "/participante/aprovar_pagamento", {
            [tipo]: {percurso: extra.percurso}[tipo] || {curso: extra.curso}[tipo] || {formacao: extra.formacao}[tipo],
            candidato: extra.utilizador,
            valor_pago_em_dinheiro: valor_pago_em_dinheiro
          }, () => {
            general.success("Pagamento validado com sucesso.", "Sucesso");
            finished && finished();
          });
        }}
        onCancel={() => window.App.hideModal()}
        confirmBtnText="Confirmar"
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <p style={{textAlign: "center"}}>
          Inserir abaixo o valor pago pelo(a) candidato(a) <span style={{whiteSpace: "nowrap"}}>{extra.nome}</span>.
        </p>
        <CustomInput
          formControlProps={{
            fullWidth: true,
            style: {padding: 0, margin: 0}
          }}
          inputProps={{
            type: "number",
            placeholder: "Valor",
            multiline: true,
            onChange: (e) => {
              valor_pago_em_dinheiro = e.target.value
            }
          }}
        />
      </SweetAlert>);
    }
  },
  PAGAR_COM_CREDITO: {
    text: "Pagar com crédito",
    color: "primary",
    callback: async (classes, extra, finished) => {

      let Content = () => {
        return <>
          <p style={{textAlign: "center"}}>
            Utilizar crédito do Porta Moedas para pagar a inscrição do(a) candidato(a) <span style={{whiteSpace: "nowrap"}}>{extra.nome}</span>.
          </p>
          <p style={{textAlign: "center"}}>
            Esta opção só poderá ser utilizada até 3 dias após a data limite do pagamento.
          </p>
        </>
      }

      window.App.openModal(<SweetAlert
        style={{width: 520}}
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Pagamento com crédito</span>
        </div>)}
        onConfirm={() => {
          window.App.hideModal();
          let tipo = extra.tipo_acontecimento;
          connection.post("pagamentos/utilizar_credito_porta_moedas", {
            acontecimento: extra.acontecimento,
            candidato: extra.utilizador,
          }, () => {
            general.success("Crédito utilizado com sucesso.", "Sucesso");
            finished && finished();
          });
        }}
        onCancel={() => window.App.hideModal()}
        confirmBtnText="Confirmar"
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <Content/>
      </SweetAlert>);
    }
  },
  APROVAR_RECURSO: {
    text: "Aprovar Recurso",
    color: "primary",
    callback: async (classes, extra, finished) => {
      window.App.openModal(<SweetAlert
        warning
        onConfirm={() => {
          window.App.hideModal();
          let tipo = extra.tipo_acontecimento;
          console.log(tipo + "/participante/aprovar_recurso")
          connection.post(tipo + "/participante/aprovar_recurso", {
            [tipo]: {formacao: extra.formacao}[tipo],
            candidato: extra.utilizador
          }, () => {
            general.success("Candidatura validada com sucesso.", "Sucesso");
            finished && finished();
          });
        }}
        onCancel={() => window.App.hideModal()}
        confirmBtnText="Confirmar"
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <p style={{textAlign: "center"}}>
          Tem a certeza que pretende aprovar o registo de <span style={{whiteSpace: "nowrap"}}>{extra.nome}</span>?
        </p>
        <p style={{textAlign: "center"}}>
          O(A) candidato(a) será aprovado como participante e será notificado(a) por email.
        </p>
      </SweetAlert>);
    }
  },
  CANCELAR_PARTICIPACAO: {
    text: "Cancelar Participação",
    color: "warning",
    callback: async (classes, extra, finished) => {
      window.App.openModal(<SweetAlert
        warning
        onConfirm={() => {
          window.App.hideModal();
          let tipo = extra.tipo_acontecimento;

          let url = tipo + "/participante/cancelar_participacao";
          if (tipo === "percurso" && !!extra.formacao_continua)
            url = tipo + "/continuos/participante/cancelar_participacao";

          connection.post(url, {
            [tipo]: {percurso: extra.percurso}[tipo] || {curso: extra.curso}[tipo] || {formacao: extra.formacao}[tipo],
            formando: extra.utilizador
          }, () => {
            general.success("Registo anulado com sucesso.", "Sucesso");
            finished && finished();
          });
        }}
        onCancel={() => window.App.hideModal()}
        confirmBtnText="Confirmar"
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.danger + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <p style={{textAlign: "center"}}>
          {extra.tipo_acontecimento === "percurso"
            ? <>Tem a certeza que pretende cancelar o percurso de <span style={{whiteSpace: "nowrap"}}>{extra.nome}</span>?</>
            : <>Tem a certeza que pretende anular o registo de <span style={{whiteSpace: "nowrap"}}>{extra.nome}</span>?</>}
        </p>
        <p style={{textAlign: "center"}}>
          {extra.tipo_acontecimento === "percurso"
            ? "O(A) formando(a) terá de repetir o percurso novamente."
            : "O(A) formando(a) deixará de ser participante e será notificado(a) por email."}
        </p>
      </SweetAlert>);
    }
  },
  REVERTER_CANCELAMENTO: {
    text: "Reverter Cancelamento",
    color: "warning",
    callback: async (classes, extra, finished) => {
      window.App.openModal(<SweetAlert
        warning
        onConfirm={() => {
          window.App.hideModal();
          let tipo = extra.tipo_acontecimento;

          let url = tipo + "/participante/inscrever";
          if (tipo === "percurso" && !!extra.formacao_continua)
            url = tipo + "/continuos/participante/inscrever";

          connection.post(url, {
            [tipo]: {percurso: extra.percurso}[tipo] || {curso: extra.curso}[tipo] || {formacao: extra.formacao}[tipo],
            formando: extra.nin
          }, () => {
            general.success("Cancelamento revertido com sucesso.", "Sucesso");
            finished && finished();
          });
        }}
        onCancel={() => window.App.hideModal()}
        confirmBtnText="Confirmar"
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <p style={{textAlign: "center"}}>
          Tem a certeza que pretende reverter o cancelamento da participação de <span style={{whiteSpace: "nowrap"}}>{extra.nome}</span>?
        </p>
        <p style={{textAlign: "center"}}>
          O(A) formando(a) voltará a ser participante do percurso e será notificado(a) por email.
        </p>
      </SweetAlert>);
    }
  },
  EDITAR_AVALIACAO: {
    text: "Editar Avaliação",
    color: "warning",
    callback: async (classes, extra, finished) => {
      let nota = extra.avaliacao;
      let marcar_presenca = extra.data_assiduidade ? true : (extra.data_falta ? false : null);

      let Content = () => {
        const nota_minima_aprovacao = ['EMSPIF', 'EMS'].includes(extra.detalhes_formacao.modulo.tipo_curso) ? 85 : 50;
        const nota_original = extra.avaliacao === null || extra.avaliacao === undefined ? 0 : extra.avaliacao;
        const [avaliacao, setAvaliacao] = useState(nota);
        const [avaliacaoInput, setAvaliacaoInput] = useState("");
        const [presente, setPresente] = useState(marcar_presenca ? true : false);

        const [anchorEl, setAnchorEl] = useState(null);
        const [setaNota, setSetaNota] = useState("50%");
        const spanRef = React.useRef();
        const sliderClasses = useSliderNotaStyles();

        // nota escrita à mão: vazio mantém a nota original (placeholder), o resto é limitado a 0-100
        function comitarNota() {
          if (avaliacaoInput === "")
            return;

          let valor = Number(avaliacaoInput);
          if (isNaN(valor) || valor < 0)
            valor = 0;
          else if (valor > 100)
            valor = 100;
          else
            valor = Math.round(valor);

          setAvaliacao(valor);
          setAvaliacaoInput(String(valor));
          nota = valor;
        }

        function handleClick() {
          setAnchorEl(spanRef.current);
        }

        function handleClose() {
          setAnchorEl(null);
        }

        const open = Boolean(anchorEl);
        const id = open ? "simple-popover" : undefined;

        return <>
          <p style={{marginTop: 10}}>Editar a presença e a avaliação do(a) formando(a)?</p>
          <ReactTable
            placeholder={"Este formando não tem avaliação para ser editada"}
            data={[extra]}
            minRows={1}
            columns={[
              {
                Header: "Nome",
                sortable: false,
                accessor: "nome"
              },
              {
                Header: "Presença",
                sortable: false,
                width: 120,
                style: {textAlign: "center"},
                headerStyle: {textAlign: "center"},
                Cell: (row) => <Switch
                  checked={presente}
                  onClick={() => {
                    marcar_presenca = !marcar_presenca;
                    setPresente(!presente);
                  }
                  }
                  color="primary"
                />
              },
              {
                Header: "Avaliação",
                sortable: false,
                width: 150,
                style: {textAlign: "center"},
                headerStyle: {textAlign: "center"},
                Cell: (row) => {
                  let reprovado = avaliacao < nota_minima_aprovacao;
                  let corNota = reprovado ? warningColor : primaryColor;

                  return <>
                  <Chip component="span" ref={spanRef} label={avaliacao}
                        disabled={!presente}
                        color="primary"
                        style={{minWidth: 50, backgroundColor: corNota}}
                        onClick={() => handleClick()}
                  />
                  <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={() => handleClose()}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                    transformOrigin={{
                      vertical: -10,
                      horizontal: 'center',
                    }}
                    PaperProps={{style: {overflow: "visible"}}}
                    TransitionProps={{
                      onEntering: (paper) => {
                        let pill = spanRef.current;
                        if (!pill)
                          return;

                        let pillRect = pill.getBoundingClientRect();

                        // o paper ainda está a meio da animação (o Grow aplica-lhe um scale), por isso o rect
                        // vinha encolhido: usa-se a geometria de layout, que o transform não afeta
                        let paperLeft = paper.offsetLeft;
                        let paperTop = paper.offsetTop;
                        let paperWidth = paper.offsetWidth;

                        // o popover pode ser encostado à margem da janela: a seta segue a pill, não o centro do popover
                        // (e desaparece se o popover não tiver ficado por baixo da pill)
                        setSetaNota(paperTop >= pillRect.bottom - 1
                          ? Math.min(Math.max(pillRect.left + pillRect.width / 2 - paperLeft, 14), paperWidth - 14)
                          : false);
                      }
                    }}
                  >
                    <div style={{
                      width: 260,
                      padding: "11px 20px",
                      paddingBottom: 5,
                      position: "relative"
                    }}>
                      {/* seta a apontar para a pill da nota */}
                      {setaNota !== false && <div style={{
                        position: "absolute",
                        top: -8,
                        left: setaNota,
                        marginLeft: -8,
                        width: 0,
                        height: 0,
                        borderLeft: "8px solid transparent",
                        borderRight: "8px solid transparent",
                        borderBottom: "8px solid #fff"
                      }}/>}
                      <p>Alterar nota:</p>
                      <div style={{display: "flex", alignItems: "center"}}>
                        <Slider
                          aria-label="Nota"
                          color="primary"
                          value={avaliacao}
                          onChange={(e, v) => {
                            setAvaliacao(v);
                            setAvaliacaoInput(String(v));
                            nota = v;
                          }}
                          valueLabelDisplay={"off"}
                          step={10}
                          marks
                          min={0}
                          max={100}
                          className={reprovado ? sliderClasses.sliderNotaAviso : sliderClasses.sliderNota}
                          style={{flex: 1, color: corNota}}
                        />
                        <TextField
                          autoFocus
                          placeholder={String(nota_original)}
                          value={avaliacaoInput}
                          onChange={(e) => {
                            let valor = e.target.value;
                            setAvaliacaoInput(valor);
                            setAvaliacao(valor === "" ? nota_original : Number(valor));
                            nota = valor === "" ? nota_original : Number(valor);
                          }}
                          onBlur={() => comitarNota()}
                          onKeyDown={(e) => {
                            if (e.key !== "Enter")
                              return;

                            e.preventDefault();
                            comitarNota();
                            handleClose();
                          }}
                          type="number"
                          inputProps={{min: 0, max: 100, step: 1, style: {textAlign: "center", padding: "6px 0"}}}
                          style={{width: 55, marginLeft: 15}}
                        />
                      </div>
                    </div>
                  </Popover>
                  </>;
                }
              }
            ]}
            defaultPageSize={20}
            showPaginationBottom={true}
            className="-striped -highlight"
          />
        </>
      }
      window.App.openModal(<SweetAlert
          style={{width: 600}}
          warning
          title={"Editar avaliação"}
          onConfirm={async () => {
            await connection.post("formacao/participante/editar_avaliacao", {
              formacao: extra.formacao,
              avaliacao: {
                formando: extra.utilizador,
                presente: marcar_presenca,
                nota: nota
              }
            }, null, null, {returnError: true});
            window.App.hideModal();
            finished && finished();
            general.success("Avaliação editada com sucesso");
          }}
          onCancel={() => window.App.hideModal()}
          confirmBtnText={"Confirmar"}
          showCancel
          cancelBtnText="Cancelar"
          confirmBtnCssClass={
            classes.button + " " + classes.primary + " " + classes.buttonConfirm
          }
          cancelBtnCssClass={
            classes.button
          }
        >
          <Content/>
        </SweetAlert>
      );
    }
  },
  ANULAR_QUALIFICACAO: {
    text: "Anular Qualificação",
    color: "warning",
    callback: async (classes, extra, finished) => {
      let tipo_acontecimento = extra.curso ? 'curso' : (extra.percurso ? 'percurso' : null);
      let estado_participacao = extra.curso ? JSON.parse(extra.estado_participacao).resultado.designacao : (extra.qualificacao_anulada_por ? 'Qualificação anulada' : 'Em progresso');
      let qualificacao_anulada = !!extra.qualificacao_anulada_por;
      let justificacao = "";
      let requesting = false;

      let Content = () => {
        const [estado, setEstado] = useState(estado_participacao);
        const [anular, setAnular] = useState(qualificacao_anulada);

        return <>
          <p style={{marginTop: 10}}>Anular a qualificação do(a) formando(a)?</p>
          <ReactTable
            placeholder={"Não existem formandos para anular a qualificação"}
            data={[extra]}
            minRows={1}
            columns={[
              {
                Header: "Nome",
                sortable: false,
                accessor: "nome"
              },
              {
                Header: "Anular Qualificação",
                sortable: false,
                width: 200,
                style: {textAlign: "center"},
                headerStyle: {textAlign: "center"},
                Cell: (row) => <Switch
                  checked={qualificacao_anulada}
                  onClick={() => {
                    qualificacao_anulada = !qualificacao_anulada;
                    setAnular(!anular)
                    setEstado(qualificacao_anulada ? "Qualificação anulada" : (extra.curso ? estado_participacao : "Em progresso"))
                  }
                  }
                  color="primary"
                />
              },
              {
                Header: "Estado",
                sortable: false,
                width: 170,
                style: {textAlign: "center"},
                headerStyle: {textAlign: "center"},
                Cell: (row) => <>
                  <Chip label={estado}
                        disabled={!anular}
                        color="primary"
                        style={{minWidth: 50, backgroundColor: !anular ? undefined : warningColor}}
                  />
                </>
              }
            ]}
            defaultPageSize={20}
            showPaginationBottom={true}
            className="-striped -highlight"
          />
          {qualificacao_anulada && <div>
            <InputLabel shrink={true}>
              Justificação
            </InputLabel>
            <CustomInput
              formControlProps={{
                fullWidth: true,
                style: {padding: 0, margin: 0}
              }}
              inputProps={{
                type: "text",
                placeholder: "A não qualificação do formando deve ser justificada.",
                multiline: true,
                rows: 3,
                onChange: (e) => {
                  justificacao = e.target.value
                }
              }}
            />
          </div>}
        </>
      }
      window.App.openModal(<SweetAlert
          style={{width: 600}}
          warning
          title={"Anular qualificação"}
          onConfirm={async () => {
            if (justificacao.trim() === "" && qualificacao_anulada)
              return general.error("É necessário justificar a anulação da qualificação.");
            if (requesting) return;
            requesting = true;
            try {
              await connection.post(`${tipo_acontecimento}/participante/anular_qualificacao`, {
                acontecimento: extra.curso || extra.percurso,
                participacao: {
                  formando: extra.utilizador,
                  qualificacao_anulada: qualificacao_anulada,
                  justificacao: justificacao
                }
              }, null, null, {returnError: true});
              window.App.hideModal();
              finished && finished();
              general.success("Anulação de qualificação editada com sucesso");
            } catch (e) {
            }
            requesting = false;
          }}
          onCancel={() => window.App.hideModal()}
          confirmBtnText={"Confirmar"}
          showCancel
          cancelBtnText="Cancelar"
          confirmBtnCssClass={
            classes.button + " " + classes.primary + " " + classes.buttonConfirm
          }
          cancelBtnCssClass={
            classes.button
          }
        >
          <Content/>
        </SweetAlert>
      );
    }
  },
  FORCAR_FEEDBACK_FORMACAO: {
    text: "Forçar Feedback",
    color: "primary",
    callback: async (classes, extra, finished) => {
      window.App.openModal(<SweetAlert
        warning
        style={{width: 520}}
        title={"Forçar Feedback"}
        onConfirm={async () => {
          await connection.post("formacao/participante/forcar_feedback", {
            id_formacao: extra.formacao,
            id_formando: extra.id
          });
          general.success("Feedback forçado com sucesso.", "Sucesso");
          window.App.hideModal();
          finished && finished();
        }}
        onCancel={() => window.App.hideModal()}
        confirmBtnText="Confirmar"
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <p>Deseja forçar o feedback do(a) formando(a) {extra.nome}?</p>
        <p>Desta forma, caso o(a) formando(a) não submeta o feedback antes do fecho do curso, ainda poderá ser qualificado(a) caso obtenha nota e presença suficientes para qualificação.</p>
      </SweetAlert>);
    }
  },
  DESFAZER_FEEDBACK_FORCADO: {
    text: "Desfazer Feedback Forçado",
    color: "warning",
    callback: async (classes, extra, finished) => {
      window.App.openModal(<SweetAlert
        warning
        style={{width: 520}}
        title={"Desfazer Feedback Forçado"}
        onConfirm={async () => {
          await connection.post("formacao/participante/desfazer_feedback_forcado", {
            id_formacao: extra.formacao,
            id_formando: extra.id
          });
          general.success("Feedback forçado desfeito com sucesso.", "Sucesso");
          window.App.hideModal();
          finished && finished();
        }}
        onCancel={() => window.App.hideModal()}
        confirmBtnText="Confirmar"
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <p>Deseja desfazer o feedback forçado do(a) formando(a) {extra.nome}?</p>
        <p>Desta forma, caso o(a) formando(a) não submeta o feedback antes do fecho do curso, não poderá ser qualificado(a) mesmo que obtenha nota e presença suficientes para qualificação.</p>
      </SweetAlert>);
    }
  },
  VERIFICAR_PAGAMENTO: {
    text: "Verificar pagamento",
    color: "info",
    callback: async (classes, extra, finished) => {
      let estado_pagamento = await connection.post("pagamentos/verificar_estado_pagamento", {
        pagamento: extra.id_pagamento
      })
      if (estado_pagamento.pago) {
        general.success("O estado do pagamento foi atualizado.", "Pagamento atualizado");
        finished && finished();
      } else {
        general.warning("O estado do pagamento continua pendente.", "Pagamento pendente");
      }
    }
  },
  ATRIBUIR_TUTOR_CURSO: {
    text: (extra) => extra.tutor_nome ? "Alterar Tutor" : "Atribuir Tutor",
    color: (extra) => extra.tutor_nome ? "info" : "primary",
    callback: async (classes, extra, finished) => {
      let nin_tutor = null;
      let tem_tutor = !!extra.tutor_nome;

      // Pre-fetch the full tutor object so UserSearch can render the preview immediately
      let tutorAtual = null;
      if (extra.tutor_nin) {
        try {
          let result = await connection.get("utilizador/pesquisar", {q: extra.tutor_nin});
          tutorAtual = result?.user || null;
          if (tutorAtual) nin_tutor = tutorAtual.NIN;
        } catch (e) {
        }
      }

      const AtribuirTutorForm = () => {
        const [tutorSelecionado, setTutorSelecionado] = React.useState(tutorAtual);

        nin_tutor = tutorSelecionado ? tutorSelecionado.NIN : null;

        return (
          <div>
            <p style={{marginBottom: "8px"}}>
              Indique o NIN do tutor a atribuir a <span style={{whiteSpace: "nowrap"}}>{extra.nome}</span>.
            </p>
            <UserSearch
              labelText="NIN do Tutor"
              formControlProps={{fullWidth: true}}
              inputProps={{type: "number", min: "0"}}
              defaultUser={tutorAtual}
              onFoundUser={(user) => {
                nin_tutor = user.NIN;
                setTutorSelecionado(user);
              }}
              onUserNotFound={() => {
                nin_tutor = null;
                setTutorSelecionado(null);
              }}
            />
          </div>
        );
      };

      window.App.openModal(<SweetAlert
        style={{width: 480}}
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>{tem_tutor ? "Alterar Tutor" : "Atribuir Tutor"}</span>
        </div>)}
        onConfirm={() => {
          if (!nin_tutor)
            return general.error("Por favor selecione um tutor válido.");
          window.App.hideModal();
          connection.post("curso/participante/atribuir_tutor", {
            curso: extra.curso,
            candidato: extra.utilizador,
            nin_tutor: String(nin_tutor)
          }, () => {
            general.success("Tutor atribuído com sucesso.", "Sucesso");
            finished && finished();
          });
        }}
        onCancel={() => window.App.hideModal()}
        confirmBtnText="Confirmar"
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <AtribuirTutorForm/>
      </SweetAlert>);
    }
  },
};

export default acoes;